export { default } from "./PaymentIcons.jsx";
